export default {
    computed: {
        isClient: function () {
            return process.env.VUE_ENV === 'client'
        }
    },
    methods: {

    }
}